import * as React from 'react';

type Props = {
  transactionRefNo: string;
};
export const PdfConcatHeader = (props: Props) => {
  const { transactionRefNo } = props;
  return <div style={{ fontSize: '2em', fontWeight: 'bold' }}>{transactionRefNo}</div>;
};
